import React from 'react';

class Table extends React.Component {
  
  render() {
    const content = this.props.content;
    const headerData = content.tableData.find(value => value.type === 'header').values;

    return (
      <div className='table-container'>
        <h4>{content.heading}</h4>
        <table className='table table-sm table-responsive'>
          <thead>
            <tr>
              <th />
              {
                headerData.map((data, i) => <th key={'th-' + data.type + '-' + i}>{data}</th>)
              }
            </tr>
          </thead>
          <tbody>
            {
              content.tableData.map((data, i) => {
                if (data.type !== 'header') {
                  return (
                    <tr key={'tr-' + data.type + '-' + i}>
                      <th>{data.type}</th>
                      {
                        data.values.map((value, j) => <th key={'th-' + data.type + '-' + i + '-' + j}>{value}</th>)
                      }
                    </tr>
                  )
                } else  {
                  return null
                }
              })
            }
          </tbody>
        </table>
      </div>
    )
  }
}

export default Table;
